import React from "react";
import axios from "axios";
import {getErrorMessageByKey, Modal, useNotification,} from "@vokymlak/kabinet-ui";
import {ROOT_URL} from "../../../config/url";

function ModalDeleteClientSecret(props) {
  const {notification} = useNotification();

  const changeDelete = (event) => {
    event.preventDefault();

    axios
      .delete("/api/alfabank/client-secret/delete", {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Секретный ключ удалён", "green");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  return (
    <Modal handleClose={() => props.handleClose()}>
      <form className="Form" onSubmit={(event) => changeDelete(event)}>
        <div
          className="Form__title"
          style={{
            fontSize: 15,
          }}
        >
          Секретный ключ (clientSecret)
          <div className="Text__signature">Удалить</div>
        </div>

        <div className="Form__actions Form__actions_center">
          <button className="Action__button Action__button_all Action__button_red">
            Удалить
          </button>
        </div>

        <div className="Form__actions Form__actions_center">
          <div className="Action__link" onClick={() => props.handleClose()}>
            Отмена
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default ModalDeleteClientSecret;
